import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getAccountingList = createAsyncThunk(
  '/GetAccountingList',
  async params => {
    const response = await axios.get(
      `/GetAccountingList/${params[0]}/${params[1]}/${params[2]}/${params[3]}/${params[4]}/${params[5]}`
    );
    return response.data;
  }
);

export const createAccounting = createAsyncThunk(
  '/CreateAccounting',
  async dto => {
    const response = await axios.post(`/CreateAccounting`, dto);
    return response.data;
  }
);

export const getErpDocumentStatus = createAsyncThunk(
  '/GetErpDocumentStatus',
  async () => {
    const response = await axios.get(`/GetErpDocumentStatus`);
    return response.data;
  }
);

export const getErpDocument = createAsyncThunk(
  '/GetErpDocument',
  async params => {
    const response = await axios.get(
      `/GetErpDocument/${params[0]}/${params[1]}/${params[2]}/${params[3]}`
    );
    return response.data;
  }
);

export const getErpMMList = createAsyncThunk('/GetErpMMList', async params => {
  const response = await axios.get(`/GetErpMMList/${params[0]}/${params[1]}`);
  return response.data;
});

export const sendErpDocument = createAsyncThunk(
  '/SendErpDocument',
  async dto => {
    const response = await axios.post(`/SendErpDocument`, dto);
    return response.data;
  }
);

export const setUnpackage = createAsyncThunk('/SetUnpackage', async dto => {
  const response = await axios.post(`/SetUnpackage`, dto);
  return response.data;
});

export const getWorkOrderErpDetails = createAsyncThunk(
  '/GetWorkOrderErpDetails',
  async params => {
    const response = await axios.get(`/GetWorkOrderErpDetails/${params[0]}`);
    return response.data;
  }
);

export const getWorkOrderUnpackagedRomania = createAsyncThunk(
  '/UnpackagedDocumentByWorkOrderRomania',
  async params => {
    const response = await axios.get(
      `/UnpackagedDocumentByWorkOrderRomania/${params[0]}`
    );
    return response.data;
  }
);

export const cancelErpDocument = createAsyncThunk(
  '/CancelErpDocument',
  async params => {
    const response = await axios.post(`/CancelErpDocument`, params);
    return response.data;
  }
);

const accountingSlice = createSlice({
  name: 'address',
  initialState: {
    loading: false,
    AccountingList: [],
    response: null,
    ErpDocumentStatusList: [],
    ErpDocumentList: [],
    ErpMMList: [],
    response: '',
    WorkOrderErpDocumentList: [],
    cancelErpResonse: ''
  },
  reducers: {},
  extraReducers: {
    [getAccountingList.pending]: state => {
      state.loading = true;
    },
    [getAccountingList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getAccountingList.fulfilled]: (state, action) => {
      state.AccountingList = action.payload;
      state.loading = false;
    },
    [createAccounting.pending]: state => {
      state.loading = true;
    },
    [createAccounting.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [createAccounting.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [getErpDocumentStatus.pending]: state => {
      state.loading = true;
    },
    [getErpDocumentStatus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getErpDocumentStatus.fulfilled]: (state, action) => {
      state.ErpDocumentStatusList = action.payload;
      state.loading = false;
    },
    [getErpDocument.pending]: state => {
      state.loading = true;
    },
    [getErpDocument.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getErpDocument.fulfilled]: (state, action) => {
      state.ErpDocumentList = action.payload;
      state.loading = false;
    },
    [getErpMMList.pending]: state => {
      state.loading = true;
    },
    [getErpMMList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getErpMMList.fulfilled]: (state, action) => {
      state.ErpMMList = action.payload;
      state.loading = false;
    },
    [sendErpDocument.pending]: state => {
      state.loading = true;
    },
    [sendErpDocument.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [sendErpDocument.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [setUnpackage.pending]: state => {
      state.loading = true;
    },
    [setUnpackage.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setUnpackage.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [getWorkOrderErpDetails.pending]: state => {
      state.loading = true;
    },
    [getWorkOrderErpDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWorkOrderErpDetails.fulfilled]: (state, action) => {
      state.WorkOrderErpDocumentList = action.payload;
      state.loading = false;
    },
    [getWorkOrderUnpackagedRomania.pending]: state => {
      state.loading = true;
    },
    [getWorkOrderUnpackagedRomania.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWorkOrderUnpackagedRomania.fulfilled]: (state, action) => {
      state.WorkOrderErpDocumentList = action.payload;
      state.loading = false;
    },
    [cancelErpDocument.pending]: state => {
      state.loading = true;
    },
    [cancelErpDocument.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [cancelErpDocument.fulfilled]: (state, action) => {
      state.cancelErpResonse = action.payload;
      state.loading = false;
    }
  }
});

export const accountingActions = accountingSlice.actions;

export default accountingSlice;
